var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{},[_c('Stadium',{attrs:{"hideStadium":_vm.hideStadium,"stadiumId":_vm.stadiumId}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }